import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Checklist from "../Checklist";

const DistroListsSection = (props) => {
  const [distroLists, setDistroLists] = useState([]);
  const { distroListsAvailable, user, updateDistroList } = props;

  useEffect(() => {
    if (distroListsAvailable) {
      const formattedDistroLists = distroListsAvailable.map((distroList) => ({
        onClick: () => updateDistroList(distroList),
        checked: user.accessList.includes(distroList),
        label: distroList,
      }));
      setDistroLists(formattedDistroLists);
    }
  }, [distroListsAvailable, user.accessList, updateDistroList]);

  return (
    <div className="my-3">
      Which Distro Lists Should the User be on?
      <Checklist checkboxes={distroLists} />
      {user.accessList && user.accessList.includes("Other (Please Specify)") && (
        <div className="my-3">
          Enter the list of Other Distros the user should be on: (Insert comma (,) between each distro)
          <Form.Control
            type="text"
            custom
            onChange={(value) =>
              props.setUser((prevUser) => ({
                ...prevUser,
                otherDistros: value.target.value,
              }))
            }
          />
        </div>
      )}
    </div>
  );
};

export default DistroListsSection;
